import { envConfig } from './envConfig';

const hostname = window.location.hostname;

export const isNonProdEnv = ['local', 'staging', 'uat', 'alpha'].includes(envConfig.VITE_AVA_ENV);

export const isSandboxEnv = envConfig.VITE_AVA_ENV === 'sandbox';

export const isProdEnv = envConfig.VITE_AVA_ENV === 'prod';

export const isDemoEnv = isNonProdEnv || isSandboxEnv;

export const isTalosWLSandboxEnv =
  isSandboxEnv && ['sandbox.whitelabel-talos.com', 'cryptoco-otc-sandbox.whitelabel-talos.com'].includes(hostname);

export const isTalosWLDemoEnv = isNonProdEnv || isTalosWLSandboxEnv;
